import React, { Fragment, useContext, useEffect, useState } from "react";
import Header from "../../components/HeaderComponent";
import useTheme from "../../hooks/ThemeHook";
import useHeadComponent from "../../hooks/HeaderHook";
import { TbReportAnalytics } from "react-icons/tb";
import Table from "../../components/table/Table";
import TableHeader from "../../components/table/TableHeader";
import TableBody from "../../components/table/TableBody";
import TableRow from "../../components/table/TableRow";
import { reprocessHeader } from "../../lib/constants/Constants";
import Pagination from "../../components/pagination/Pagination";
import Modal from "../../components/modal/ModalComponent";
import { reprocessModalText } from "../../lib/constants/text/Text";
import LoadingComponent from "../../components/loading/Loading";
import useReprocess from "../../hooks/ReprocessHook";
import { MdRestartAlt } from "react-icons/md";
import useUserLogin from "../../hooks/UserLoginhook";
import { AutoLogout } from "../../components/AutoLogoutComponent";
import { useManualUpload, usePagination } from "../../hooks";
import { AuthContext } from "../../components/AuthContextComponent";
import { forgetPassword } from "../../api/FetchAPI";
import { SecurityQuestionRequestArray } from "../../lib/interfaces";
import UpdatePassword from "../../components/updatepassword/UpdatePassword";
import SecurityQuestion from "../../components/SecurityQuestion";
import { FetchErr } from "../../lib/helpers/UnhandledError";
import { showAlert } from "../../promptMessages/PromptMessages";
import { ALERTMSG } from "../../lib/enums";

const Reprocess = () => {
  const { theme } = useTheme();
  const { customColor } = useUserLogin();
  const { Balance, customBannerImg } = useHeadComponent();
  const [isLoading, setIsLoading] = useState(false);
  const {
    batchNumber,
    isDone,
    isGenerating,
    reprocessData,
    isModalOpen,
    selectedRows,
    selectAll,
    totalDisplay,
    setIsModalOpen,
    handleMCashForceCommit,
    handleInputChange,
    handleReason,
    handleReprocessModalClick,
    handleReprocessData,
    handleCheckboxChange,
    handleSelectAll,
    handleSubmit,
    setIsDone,
    setIsGenerating,
    setSelectedRows,
    setReprocessData,
    setTotalDisplay,
  } = useReprocess();

  const { userInfo, username } = useContext(AuthContext);
  const { openOTP } = useManualUpload();
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);

  const [redirectModal, setRedirectModal] = useState(false);

  const themeBackground = userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo?.theme === "DARK" ? "#fafbfc" : "";
  const { pwdUpdate, category } = userInfo || {};

  const redirectState = !!(redirectModal && category === "EXTERNAL");

  const firstTimeLoginState = !!(pwdUpdate && category === "EXTERNAL");

  useEffect(() => {
    setIsLoading(true);
    setTimeout(async () => {
      setIsLoading(false);
    }, 3000);
  }, []);

  useEffect(() => {
    const fetchCurrentUserQuestion = async () => {
      // try {
      const response: any = await forgetPassword(username);

      const { respCode, respMsg } = response;

      if (respCode === 2000) {
        if (
          response.questionInfo === null ||
          response.questionInfo.length < 2
        ) {
          setCurrentQuestions(null);
          setRedirectModal(true);
        } else {
          setCurrentQuestions(response.questionInfo);
        }
      } else {
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          `${respMsg} (${respCode})`,
          "error",
          customColor,
          themeBackground,
          themeTextColor
        );
      }
      // } catch (error: any) {
      //   FetchErr(error, themeBackground, customColor, themeTextColor);
      // }
    };

    let count = 0;
    if (count === 0) {
      const timer = setTimeout(() => {
        fetchCurrentUserQuestion();
      }, 1000);
      count++;
      return () => clearTimeout(timer);
    }
  }, [username]);

  const rows = Array.isArray(reprocessData) ? reprocessData : [];

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(rows);

  const renderConditionalComponent = () => {
    if (pwdUpdate && category === "EXTERNAL") {
      return <UpdatePassword />;
    } else if (redirectModal && category === "EXTERNAL") {
      return <SecurityQuestion />;
    }
    return null; // Return null if neither condition is met
  };

  return (
    <div>
      <Header Balance={Balance} theme={theme} />
      <AutoLogout
        openOTP={openOTP}
        redirectModal={redirectState}
        redirectChangePassword={firstTimeLoginState}
      />
      {isLoading ? (
        <Fragment>
          <div className="flex justify-center max-w-[1240px] mx-auto px-4 h-full items-center p-96">
            <LoadingComponent customColor={customColor} />
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col items-center justify-start gap-2 px-10 py-5 mx-auto lg:flex-row md:flex-row lg:py-0 sm:py-5 md:py-5">
              <div className={`flex flex-col text-custom-micro`}>
                <label className={`ml-1 pl-1 pb-1`}>Batch No</label>
                <input
                  onChange={handleInputChange}
                  value={batchNumber}
                  required
                  type="text"
                  className={`rounded-md p-2 h-[30px] w-[311px] border border-gray-300 hover:bg-slate-100 text-custom-petite`}
                />
              </div>

              <div className="flex lg:py-[23px] px-2 items-center justify-center md:justify-start">
                <button
                  type="submit"
                  className={`flex items-center justify-center gap-2 px-4 py-2 mt-5 w-[170px] h-[30px] text-custom-micro bg-custom-default text-white rounded-md ${
                    customColor
                      ? `hover:scale-105 transition-all duration-300`
                      : `hover:bg-custom-default-hover hover:shadow-lg   hover:shadow-red-500/40`
                  }`}
                  style={{ backgroundColor: customColor }}
                >
                  <TbReportAnalytics className="text-lg" /> Generate Report
                </button>
              </div>
            </div>
          </form>

          {isGenerating ? (
            <Fragment>
              <div className="flex justify-center max-w-[1240px] mx-auto px-4 h-full items-center p-80">
                <LoadingComponent customColor={customColor} />
              </div>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
          {isDone ? (
            <Fragment>
              <Table>
                <TableHeader>
                  <TableRow
                    data={reprocessHeader}
                    isReprocess
                    isHeader
                    onCheckBoxAllChange={handleSelectAll}
                    isCheckedAll={selectAll}
                  />
                </TableHeader>
                <TableBody>
                  {currentItems.map((rowData: any, index: number) => {
                    return (
                      <TableRow
                        key={index}
                        index={index}
                        data={[
                          rowData.refno || "",
                          rowData.rcvrContactNo || "",
                          rowData.sndrBusinessName || "",
                          rowData.rcvrFName || "",
                          rowData.rcvrMName || "",
                          rowData.rcvrLName || "",
                          rowData.destCurrency || "",
                          rowData.destPrincipalAmount.toLocaleString() || "",
                          rowData.destFee || 0,
                        ]}
                        isReprocess
                        onApprove={() => handleMCashForceCommit(rowData.refno)}
                        onCheckBoxChange={() =>
                          handleCheckboxChange(rowData.refno)
                        }
                        isChecked={selectedRows.includes(rowData.refno)}
                      />
                    );
                  })}
                </TableBody>
              </Table>

              <div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>

              <div className="flex flex-row flex-wrap items-center justify-between w-full py-5 mx-auto ">
                <div className="flex flex-col gap-1 pl-10 md:gap-2 md:w-96 text-custom-micro md:text-custom-petite">
                  <div className="flex flex-row items-center">
                    <p className="w-full"> Total Count (PHP) :</p>
                    <p className="w-full text-center">
                      {" "}
                      {totalDisplay.totalPHP}
                    </p>
                  </div>
                  <div className="flex flex-row items-center">
                    <p className="w-full"> Total Principal (PHP) :</p>
                    <p className="w-full text-center">
                      {" "}
                      {totalDisplay.totalPrincipalPHP.toLocaleString()}
                    </p>
                  </div>
                  <div className="flex flex-row items-center">
                    <p className="w-full"> Total Charges (PHP) : </p>
                    <p className="w-full text-center">
                      {" "}
                      {totalDisplay.totalFeePHP.toLocaleString()}
                    </p>
                  </div>
                </div>

                <button
                  onClick={handleReprocessModalClick}
                  disabled={selectedRows.length === 0}
                  className={`flex items-center justify-center py-2 w-[120px] h-[30px] bg-custom-default text-white rounded-md mr-10 gap-2 text-custom-micro ${
                    customColor
                      ? `hover:scale-105 transition-all duration-300`
                      : `hover:bg-custom-default-hover hover:shadow-lg   hover:shadow-red-500/40`
                  } ${
                    selectedRows.length === 0
                      ? `bg-opacity-30 opacity-50 transition-all duration-1000 cursor-not-allowed`
                      : ``
                  }`}
                  style={{ backgroundColor: customColor }}
                >
                  <MdRestartAlt className="text-lg" /> Reprocess
                </button>
              </div>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </Fragment>
      )}

      {isModalOpen && (
        <Modal
          isClose={false}
          userId={""}
          otpTimer={0}
          otpType={""}
          label={reprocessModalText}
          type="REPROCESS"
          modalClose={setIsModalOpen}
          toggleClose={() => handleReason(false)}
          data={selectedRows}
          batchNumber={batchNumber}
          isDone={setIsDone}
          isGenerating={setIsGenerating}
          isReprocessData={setReprocessData}
          isTotalDisplay={setTotalDisplay}
          selectedRows={setSelectedRows}
        />
      )}

      {renderConditionalComponent()}
    </div>
  );
};

export default Reprocess;
